import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { VendorReport } from "../../../components/Reports/VendorReport/VendorReport";

export interface IVendorReportPage {}

export const VendorReportPage: FC<IVendorReportPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Vendors"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<VendorReport />}
    />
  );
};
